import Accounts from './components/AccountsTable'
import SystemMapping from './components/Manage'
import Users from './components/Users'
import Notification from './components/Notification'
import SalesforcePage from './components/SalesforcePage'
import OECentralKnovioPage from './components/OECentralKnovioPage'
import OneWayAttendeeRegistrationForm from './components/OneWayAttendeeRegistrationForm'
import { ACCOUNTS_PATH, SALESFORCE_PATH, TEAMS_PATH, USERS_PATH,OECENTRAL_PATH, ONE_WAY_ATTENDEE_REGISTRATION_PATH, SAML_ONE_WAY_ATTENDEE_REGISTRATION_PATH, CITI_SSO_IFRAME_PATH } from './components/Constants'
import SamlRegistrationForm from './components/SamlOneWayAttendeeRegistrationForm'
import CitiSsoIframeForm from './components/CitiSsoIframeForm'
import TeamsPage from './components/TeamsPage'
const routes = [
    {
        path: OECENTRAL_PATH,
        component: OECentralKnovioPage
    },
    {
        path: '/accounts/accountmapping/:id',
        component: SystemMapping
    },
    {
        path: '/accounts/notification/:id',
        component: Notification
    },
    {
        path: ACCOUNTS_PATH,
        component: Accounts
    },
    {
        path: USERS_PATH,
        component: Users
    },
    {
        path: SALESFORCE_PATH,
        component: SalesforcePage
    },
    {
        path: TEAMS_PATH,
        component: TeamsPage
    },
    {
        path: ONE_WAY_ATTENDEE_REGISTRATION_PATH,
        component: OneWayAttendeeRegistrationForm,
    },
    {
        path: SAML_ONE_WAY_ATTENDEE_REGISTRATION_PATH,
        component: SamlRegistrationForm,
    },
    {
        path: CITI_SSO_IFRAME_PATH,
        component: CitiSsoIframeForm,
    },
    {
        path: '/',
        component: Accounts
    }
];

export default routes;